/**
 * Chart series colours, the same as the mobile app's battery plan and
 * flow charts (mobile/src/components/BatteryPlanCard.tsx, DayFlowChart.tsx)
 * so a series reads the same on the web and in the app.
 */
export const PLAN_COLORS = {
  charge: '#4b8fe8', // battery charging / buy windows
  sell: '#f26a1b', // battery selling / sell windows
  powerHome: '#7c6ce0', // battery powering the home / self-consumption
  ev: '#ec4899',
  soc: '#25a35a', // the app's SOC line: #25864b (light) .. #2f9e5a (dark)
  solar: '#f5b83d',
  importPrice: '#4b8fe8',
  exportPrice: '#f26a1b',
  freeCharge: '#0ea5e9',
  happyHour: '#eab308', // Flow Power Happy Hour feed-in window
} as const;

export const FLOW_COLORS = {
  import: '#4b8fe8',
  consumption: '#cdc5bd',
  production: '#f7a468',
  export: '#f26a1b',
} as const;
